import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import { useSelector } from "react-redux";
import { API_ENDPOINT } from "../../../services/api/resources";
import classes from "./VendorsTab.module.css";
import tableClasses from "../../../components/common/AnalysisTable/AnalysisTable.module.css";

const VendorVerificationTable = () => {
  const loginData = useSelector((state) => state.loginData.value);
  const buyer_token = loginData?.user?.token;

  const [companyLogs, setCompanyLogs] = useState([]);

  const fetchVendorVerificationLogs = async () => {
    try {
      const response = await axios.post(
        API_ENDPOINT.get_vendor_verification_logs,
        {
          buyer_token: buyer_token,
        }
      );
      setCompanyLogs(response.data);
    } catch (error) {
      console.error("Error fetching logs:", error);
    }
  };

  useEffect(() => {
    fetchVendorVerificationLogs();
  }, []);

  return (
    <>
      <HeaderTitle titleText={"KYC Re-Verification Analysis"} />

      <div className={tableClasses.sectionGap}>
        {companyLogs &&
          companyLogs.map((company, index) => (
            <div className={classes.divShadow} key={index}>
              <Accordion defaultExpanded={false} className={classes.analysisAccordion}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className={classes.analysisAccordionSummary}
                >
                  <p className={classes.accordionHeader}>
                    <span>Company: {company.company_name}</span>
                  </p>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper} className={tableClasses.tableSurface}>
                    <div className={tableClasses.tableScroll}>
                      <Table
                        className={`${tableClasses.tableRoot} ${tableClasses.tableRootCompact}`}
                      >
                        <TableHead>
                          <TableRow className={tableClasses.headerRow}>
                            <TableCell className={tableClasses.headerCell}>
                              Sl. No.
                            </TableCell>
                            <TableCell className={tableClasses.headerCell}>
                              Verified On
                            </TableCell>
                            <TableCell className={tableClasses.headerCell}>
                              Overall Status
                            </TableCell>
                            <TableCell className={tableClasses.headerCell}>
                              PAN Status
                            </TableCell>
                            <TableCell className={tableClasses.headerCell}>
                              GST Status
                            </TableCell>
                            <TableCell className={tableClasses.headerCell}>
                              Bank Status
                            </TableCell>
                            <TableCell
                              className={`${tableClasses.headerCell} ${tableClasses.bodyCellWrap}`}
                            >
                              Message
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {company.logs.length > 0 ? (
                            company.logs.map((log) => (
                              <TableRow key={log.id} className={tableClasses.bodyRow}>
                                <TableCell className={tableClasses.bodyCell}>
                                  {log.id}
                                </TableCell>
                                <TableCell className={tableClasses.bodyCell}>
                                  {new Date(log.verified_on).toLocaleDateString()}
                                </TableCell>
                                <TableCell className={tableClasses.bodyCell}>
                                  {log.overall_status}
                                </TableCell>
                                <TableCell className={tableClasses.bodyCell}>
                                  {log.pan_status}
                                </TableCell>
                                <TableCell className={tableClasses.bodyCell}>
                                  {log.gst_status}
                                </TableCell>
                                <TableCell className={tableClasses.bodyCell}>
                                  {log.bank_status}
                                </TableCell>
                                <TableCell
                                  className={`${tableClasses.bodyCell} ${tableClasses.bodyCellWrap}`}
                                >
                                  {log.message}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={7}
                                align="center"
                                className={tableClasses.emptyState}
                              >
                                No data found
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </div>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
      </div>
    </>
  );
};

export default VendorVerificationTable;
